$(".js-login").on("click", function (e) {
    var that = $(e.currentTarget), target = that.attr("data-modal-target") || null;
    e.preventDefault();

    if (target) {
        $(target).modal();
    }
});